export interface GoogleAnalyticsChatMessage {
    analyticsType: string;
    origin: string;
    receiverId: number;
}

export class GoogleAnalyticsEventNames {
    atualizarTelaCentral: string = 'exec_central_semaforo_atualizar_tela'
    envioMensagem: string = 'exec_send_notification'
}
